import { combineReducers } from 'redux'

import reducers from './reducers'

export const reducer = combineReducers({
  errors: reducers,
})

export default reducer
